module.exports = __webpack_public_path__ + "static/media/Logo hotel dorado.81180dd6.svg";